<template>
  <v-container fluid class="background-img login-page-new d-flex justify-center align-center">
    <v-card max-width="600px" class="card-title px-6 py-13" color="white">
      <v-card-title class="text-topic text-h5 text-center justify-center font-weight-bold py-4 mb-5">
        เงื่อนไข และข้อตกลง
      </v-card-title>
      <v-card-text class="text-body-1 card-title-2 pa-6">
        <div class="text-primary font-weight-bold mb-3">
          สถาบันการแพทย์ฉุกเฉินแห่งชาติ
        </div>
        <div class="text-grey-darken-3">
          สถาบันการแพทย์ฉุกเฉินแห่งชาติ (สพฉ.) ขอความยินยอม และขออนุญาต
          ในการเปิดเผยข้อมูลส่วนบุคคล จากท่านว่าข้อมูลที่แจ้งจะนำไปใช้ในการ
          ประมวลผลการตอบโต้ภาวะฉุกเฉิน และที่เกี่ยวข้องกับระบบการแพทย์ฉุกเฉิน
          เท่านั้น โดยจะไม่นำไปใช้เพื่อประโยชน์ส่วนตัวสำหรับข้อมูลด้านอื่นที่สำคัญ
          สพฉ.จะไม่ทำการเปิดเผยต่อสาธารณะ จึงขออนุญาต และขอขอบพระคุณ
          ในข้อมูลดังกล่าว
        </div>
      </v-card-text>
      <v-card-actions class="justify-center mt-3 mb-0">
        <v-btn to="/login" class="btn-cancel">ไม่ยอมรับ</v-btn>
        <v-btn @click="goToPath()" class="btn-success">ยอมรับ</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
export default {
  methods: {
    goToPath() {
      const type = this.$route.query.type
      if (type === 'search_certificated') {
        this.$router.push('/search_certificated')
      } else if (type === 'upload_image') {
        this.$router.push('/upload_image')
      }
    }
  }
}
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: "Noto Sans Thai", sans-serif !important;
  color: #000;
}

/* Card */
.card-title {
  padding: 30px !important;
  width: 630px !important;
  min-height: 469px !important;
  border-radius: 12px;
  background-color: #ffffff;
}

.card-title-2 {
  background-color: #f7fbfd;
}

/* Text styles */
.text-topic {
  font-family: "Noto Sans Thai", sans-serif !important;
  font-weight: 700;
  color: #1b577e;
  font-style: normal;
  font-size: 20px;
  padding: 0px !important;
}

.text-primary {
  color: #1b577e !important;
  font-weight: 600 !important;
  font-size: 16px !important;
}

.text-grey-darken-3 {
  text-indent: 2em;
  color: #333333 !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  margin-bottom: 80px;
}

/* Buttons */
.btn-cancel {
  width: 130px !important;
  height: 48px !important;
  border-radius: 12px;
  padding: 12px 16px;
  border: 1px solid #1b577e;
  background-color: #ffffff;
  color: #1b577e !important;
  cursor: pointer;
  transition: 0.2s;
}

.btn-cancel:hover {
  background-color: #f5f5f5;
}

.btn-success {
  width: 130px !important;
  height: 48px !important;
  border-radius: 12px;
  padding: 12px 16px;
  background-color: #1b577e !important;
  color: #ffffff !important;
  border: none;
  cursor: pointer;
  transition: 0.2s;
}

.btn-success:hover {
  background-color: #15425d !important;
}
</style>
